/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Uploader_Preview_AltInputs */

const en_common_uploader_preview_alt = /** @type {(inputs: Common_Uploader_Preview_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview`)
};

const zh_common_uploader_preview_alt = /** @type {(inputs: Common_Uploader_Preview_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览`)
};

/**
* | output |
* | --- |
* | "Preview" |
*
* @param {Common_Uploader_Preview_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_uploader_preview_alt = /** @type {((inputs?: Common_Uploader_Preview_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Uploader_Preview_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_uploader_preview_alt(inputs)
	return zh_common_uploader_preview_alt(inputs)
});
export { common_uploader_preview_alt as "common.uploader.preview_alt" }